var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9062 2.67795H18.75V1.55295C18.75 1.13876 18.4142 0.802948 18 0.802948C17.5858 0.802948 17.25 1.13876 17.25 1.55295V2.67795H6.75V1.55295C6.75 1.13876 6.41423 0.802948 6 0.802948C5.58577 0.802948 5.25 1.13876 5.25 1.55295V2.67795H3.09375C1.38783 2.67795 0 4.06578 0 5.7717V21.7092C0 23.4151 1.38783 24.8029 3.09375 24.8029H20.9062C22.6122 24.8029 24 23.4151 24 21.7092V5.7717C24 4.06578 22.6122 2.67795 20.9062 2.67795ZM22.5 21.7092C22.5 22.5894 21.7865 23.3029 20.9062 23.3029H3.09375C2.21353 23.3029 1.5 22.5894 1.5 21.7092V9.28732C1.5 9.1579 1.60495 9.05295 1.73438 9.05295H22.2656C22.395 9.05295 22.5 9.1579 22.5 9.28732V21.7092Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.95c6bacef9360a0406b839daf71fe556.svg";
export { ForwardRef as ReactComponent };